'use strict';
import * as _ from 'lodash';

module.exports = function createNgModule(angular,config){

    const module =  angular.module(config.name, config.deps)
    .config(function ($stateProvider) {
        _.each(config.states,(state,stateName)=>{
            _.each(state.route.views,(value,key)=>{
                value.controller = value.controller(angular,config);
            });
            $stateProvider.state(stateName,state.route);  
        });

    })
    .run(function ($rootScope,$state) {

    });

    _.each(config.services, (m,key) => {
        _.each(m(angular, config),(value,key) => {
            module.factory(key,value);
        });
    });
    _.each(config.filters, (m,key) => {
        _.each(m(angular, config),(value,key) => {
            module.filter(key,value);
        });
    });
    _.each(config.directives, (m,key) => {
        _.each(m(angular, config),(value,key) => {
            module.directive(key,value);
        });
    });
	    

	return module; 
}